import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";
import "./BookingConfirmation.css";

const BookingConfirmation = () => {
  const { user: currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [bookingDetails, setBookingDetails] = useState(null);

  useEffect(() => {
    // Get booking details from navigation state
    const bookingData = location.state?.bookingDetails;

    if (!bookingData) {
      // If no booking details provided, redirect to dashboard
      navigate("/dashboard");
      return;
    }

    setBookingDetails(bookingData);
  }, [location.state, navigate]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };
  const handleGoToDashboard = () => {
    navigate("/dashboard", {
      state: { fromBookingConfirmation: true },
    });
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatTime = (timeStr) => {
    return timeStr;
  };

  if (!bookingDetails) {
    return (
      <div className="booking-confirmation">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading booking details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="booking-confirmation">
      <header className="confirmation-header">
        <div className="header-content">
          <img src={logo} alt="Steam & Drive" className="confirmation-logo" />
          <div className="user-info">
            <span>
              Welcome, {currentUser?.displayName || currentUser?.email}
            </span>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="confirmation-container">
        <div className="confirmation-content">
          <div className="success-icon">
            <div className="checkmark">✓</div>
          </div>

          <h1>Booking Confirmed!</h1>
          <p className="confirmation-subtitle">
            Your car wash service has been successfully booked.
          </p>

          <div className="booking-details-card">
            <h2>Booking Details</h2>

            <div className="detail-row">
              <span className="detail-label">Date:</span>
              <span className="detail-value">
                {formatDate(bookingDetails.bookingDate)}
              </span>
            </div>

            <div className="detail-row">
              <span className="detail-label">Time:</span>
              <span className="detail-value">
                {formatTime(bookingDetails.slot?.startTime)} -{" "}
                {formatTime(bookingDetails.slot?.endTime)}
              </span>{" "}
            </div>

            <div className="detail-row">
              <span className="detail-label">Credits Used:</span>
              <span className="detail-value">1 credit</span>
            </div>

            {bookingDetails.bookingId && (
              <div className="detail-row">
                <span className="detail-label">Booking ID:</span>
                <span className="detail-value">
                  #{bookingDetails.bookingId}
                </span>
              </div>
            )}
          </div>

          <div className="action-buttons">
            <button onClick={handleGoToDashboard} className="primary-btn">
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmation;
